import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import AppContext from "~/contexts/App"

import React, { useContext } from "react"
import { useHistory } from "react-router"

import Box from "~/components/Common/Box"
import useStyles from "./styles"

const CoursesAttachedToLessonDialog = () => {
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()

  const smDown = useMediaQuery(theme.breakpoints.down("sm"))

  const { dialogs, closeDialog } = useContext(AppContext)
  const thisDialog = dialogs?.["coursesAttachedToLessonDialog"] || {}
  const { open = false, data } = thisDialog

  let coursesData = thisDialog?.data?.data || []

  const handleClose = () => {
    closeDialog("coursesAttachedToLessonDialog", false)
  }
  const openCourse = (id) => {
    history.push(`/courses/${id}`)
    handleClose()
  }

  return (
    <Dialog
      classes={{ paperWidthSm: classes.dialogMinHeight }}
      open={open}
      fullScreen={smDown}
    >
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <Typography variant="h2" className={classes.title}>
          Courses
        </Typography>
      </DialogTitle>
      <DialogContent classes={{ root: classes.contentRoot }}>
        {coursesData.map((course, i) => {
          return (
            <>
              <Box
                display="flex"
                alignItems="center"
                key={i}
                paddingTop="8px"
                paddingRight="24px"
                paddingLeft="24px"
                height="45px"
              >
                <Typography
                  style={{ width: "50%" }}
                  color="primary"
                  variant="subtitle2"
                >
                  {course?.name}
                </Typography>

                <Button
                  className={classes.viewBtn}
                  color="secondary"
                  onClick={() => openCourse(course?.course_id)}
                >
                  View
                </Button>
              </Box>
              <Divider />
            </>
          )
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  )
}

CoursesAttachedToLessonDialog.propTypes = {}

export default CoursesAttachedToLessonDialog
